import { CommonModule, DecimalPipe } from '@angular/common';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { IHowdenEnvironment, IPackageJsonWrapper, provideHowdenCore } from '@howdeniberia/core-front';
import { ScatterChart } from 'echarts/charts';
import { DataZoomComponent, GridComponent, LegendComponent, TooltipComponent } from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { NgxEchartsDirective, provideEchartsCore } from 'ngx-echarts';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ApiConfigurations } from 'src/environments/api-configurations';
import { environment } from 'src/environments/environment';
import packageJson from '../../package.json';
import { AppRoutes } from './app-routing';
import { provideCoreServices } from './core/core.provider';

echarts.use([
  CanvasRenderer,
  GridComponent,
  DataZoomComponent,
  LegendComponent,
  TooltipComponent,
  ScatterChart
]);

export const appConfig: ApplicationConfig = {
  providers: [
    DecimalPipe,
    importProvidersFrom([
      CommonModule,
      BrowserModule,
      CarouselModule,
      NgxEchartsDirective
    ]),
    provideEchartsCore({ echarts }),
    provideRouter(AppRoutes),
    provideCoreServices(),
    provideHowdenCore({
      environment: environment as IHowdenEnvironment,
      packageJson: packageJson as unknown as IPackageJsonWrapper,
      apiConfigurations: ApiConfigurations
    })
  ]
};
